// extracted by mini-css-extract-plugin
module.exports = {"notificationAuthor":"styles_notificationAuthor__Ttbc2","notificationAuthorAvatar":"styles_notificationAuthorAvatar__3M189"};